import { render, staticRenderFns } from "./UploadEnclosure.vue?vue&type=template&id=9d98c634"
import script from "./UploadEnclosure.vue?vue&type=script&lang=ts"
export * from "./UploadEnclosure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports